
export default function MySubscriptionRow({ item }) {
	const isActive = item.state === "active";

	return (
		<div
			className={[
				"relative overflow-hidden rounded-[14px] border bg-white px-4 py-4",
				isActive ? "border-darkBlue/15" : "border-darkBlue/10 opacity-90",
			].join(" ")}
		>
			<div
				className="absolute inset-y-0 right-0 w-[3px] bg-gradient-to-b from-cta to-darkBlue"
				aria-hidden
			/>
			<div className="flex flex-col gap-3 pr-2 sm:flex-row sm:items-center sm:justify-between">
				<div className="text-right">
					<p className="font-Vazir-600 text-[15px] text-darkBlue">
						{item.plan_title}
					</p>
					<p className="mt-1 font-Vazir-400 text-[13px] text-darkBlue/55">
						باقی‌مانده:{" "}
						<span className="font-Vazir-600 text-darkBlue">
							{item.remaining_usage} از {item.usage_limit}
						</span>
					</p>
				</div>
				<div className="flex flex-wrap items-center gap-2 sm:justify-end">
					<span className="rounded-[8px] bg-lightCta px-2.5 py-1 font-Vazir-400 text-[12px] text-darkBlue/70">
						انقضا:{" "}
						{new Date(item.expires_at).toLocaleDateString("fa-IR")}
					</span>
					<span
						className={[
							"rounded-[8px] px-2.5 py-1 font-Vazir-600 text-[12px]",
							isActive
								? "bg-[#EAF8F2] text-secondary-green2"
								: "bg-lightCta text-darkBlue/55",
						].join(" ")}
					>
						{isActive ? "فعال" : "منقضی"}
					</span>
				</div>
			</div>
		</div>
	);
}
